import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import { fa } from "typed-font-awesome";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { componentToRx } from "app/logic/rx";
import { PartidasAclaracionGuiasList } from "./guias/list";
import { PartidasAclaracionFacturasList } from "./facturas/list";
import { PartidasAclaracionDepositosList } from "./depositos/list";
import { TotalConceptoList } from "./totales";

type Entity = models.PartidaAclaracion;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => Promise<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
    permisos: models.Rol;
}

/**
* Componente para editar un Entity
*/
export class PartidaAclaracionNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaAlDia: validation.required,
        };
    }

    totales = async () => {
        const ret = await resources.PartidasAclaracion.GetTotal(this.props.value);
        return ret;
    }

    render() {
        const total = this.totales();
        const { value, onGuardar, nuevo, onChange } = this.props;
        const titulo = (this.props.nuevo ? "Agregar" : "Editar") + " partida aclaración";
        const getField = this.getField;

        const Date = getField(kea.DateTime);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Sucursal = getField(selectores.Sucursal);
        const Guias = getField(PartidasAclaracionGuiasList);
        const Facturas = getField(PartidasAclaracionFacturasList);
        const Depositos = getField(PartidasAclaracionDepositosList);

        return (
            <div>
                <kea.Title titulo={titulo} onRegresar={() => history.go("/operativa/partidasaclaracion")} />
                <TotalConceptoList value={total} color="success" />
                {kea.autogrid(6, [
                    <Date field="FechaAlDia" label="Fecha" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                ])}
                
                <Guias field="Guias" />
                <Facturas field="Facturas" />
                <Depositos field="Depositos" />
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const PartidaAclaracionForm = componentToRx(PartidaAclaracionNoRx); 


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/form.tsx